import { ORIGINAL_ACTION_TICK_MS } from '../shared/attack-timing';

/** EnergyView.calcForce adds raw force 20/2000 per 25 fps frame, then reverses. */
export function chargePower(elapsedMs: number) {
  const ticks = Math.floor(Math.max(0, elapsedMs) / ORIGINAL_ACTION_TICK_MS);
  return { power: Math.max(0, ticks <= 100 ? ticks : 200 - ticks), expired: ticks >= 200 };
}

/** Display-clock in-between; firing and expiry still use native 40ms ticks. */
export function chargeVisualPower(elapsedMs: number): number {
  const ticks = Math.max(0, Math.min(200, elapsedMs / ORIGINAL_ACTION_TICK_MS));
  return ticks <= 100 ? ticks : 200 - ticks;
}
